import { IPostModel } from '../../models';

// Chỉ cần id của quảng cáo đã lấy sẵn; kiểu đầy đủ ở api/ads.
export interface ReelAd { campaignId: string; creativeId: string }

export const REEL_AD_EVERY = 6;

export type ReelDisplayItem<A extends ReelAd = any> =
  | { kind: 'post'; post: IPostModel; postIndex: number }
  | { kind: 'ad'; afterPost: IPostModel; key: string; ad: A };

/** Khoá ổn định của một mục (id reel hoặc key ô quảng cáo). */
export const displayKey = (d: ReelDisplayItem): string => (d.kind === 'post' ? d.post.id : d.key);

/** Trộn thẻ quảng cáo sau mỗi `every` reel (postId của thẻ = reel ngay trước). */
export const buildReelDisplayList = <A extends ReelAd>(
  posts: IPostModel[],
  adsByPostId: Record<string, A> = {},
  every: number = REEL_AD_EVERY
): ReelDisplayItem<A>[] => {
  const out: ReelDisplayItem<A>[] = [];
  posts.forEach((post, i) => {
    out.push({ kind: 'post', post, postIndex: i });
    const ad = adsByPostId[post.id];
    // Chỉ có ô quảng cáo khi đã lấy được quảng cáo cho vị trí này (serve rỗng ⇒ không chèn).
    if ((i + 1) % every === 0 && ad) out.push({ kind: 'ad', afterPost: post, key: `ad-${post.id}`, ad });
  });
  return out;
};

/** Chỉ số reel (trong danh sách gốc) của mục hiển thị đang xem; quảng cáo ⇒ reel ngay trước. */
export const activePostIndexOf = (list: ReelDisplayItem[], displayIndex: number): number => {
  for (let i = Math.min(displayIndex, list.length - 1); i >= 0; i--) {
    const d = list[i];
    if (d.kind === 'post') return d.postIndex;
  }
  return 0;
};

/** Chỉ số trong danh sách hiển thị của reel có id này (-1 nếu không có). */
export const findDisplayIndexByPostId = (list: ReelDisplayItem[], id: string): number =>
  list.findIndex((d) => d.kind === 'post' && d.post.id === id);

/** Mục reel thật tại chỉ số hiển thị (null nếu là thẻ quảng cáo): dùng để chỉ đếm lượt xem cho reel. */
export const postAtDisplayIndex = (list: ReelDisplayItem[], i: number): IPostModel | null => {
  const d = list[i];
  return d && d.kind === 'post' ? d.post : null;
};
